import type { ReactNode, Ref } from 'react'
import styles from './Profile.module.css'
import { SplitView, SplitViewSide, SplitViewMain } from '@/components/SplitView'
import { ScrollView } from '@/components/ScrollView'

export interface ProfileProps {
  nav: ReactNode
  scrollRef: Ref<HTMLDivElement>
  children?: ReactNode
}

export function Profile({ nav, scrollRef, children }: ProfileProps) {
  return (
    <div className={styles.root}>
      <SplitView>
        <SplitViewSide>{nav}</SplitViewSide>
        <SplitViewMain>
          <ScrollView ref={scrollRef}>{children}</ScrollView>
        </SplitViewMain>
      </SplitView>
    </div>
  )
}
